import { ComponentType } from 'react';

export enum StickyPosition {
    RIGHT = 'right',
    LEFT = 'left',
}

export interface Column<T = string> {
    id: T;
    title: string;
    sticky?: StickyPosition;
    width?: number | 'max-content';
    component?: ComponentType<{ [key: string]: any }>;
    alignHeader?: 'center' | 'left' | 'right';
    isSorted?: boolean;
}

export interface ConfigurableColumns {
    allColumns: Column[];
    columnVisibility: { [key: string]: boolean };
    setColumnVisibility: React.Dispatch<React.SetStateAction<{ [key: string]: boolean }>>;
}
